<template>
  <div class="adminUserList">
    <div class="row">
        <div class="col-md-5">
          <Breadcumb :title="$t('users_list')" :breadcumb-data="breadcumbData">
            <b-btn v-on:click="$refs.formodal.open()" class="mr-2 mt-3 mb-3" variant="primary" style="float:right">
              {{ $t('addUserFile') }}
            </b-btn>
          </Breadcumb>
      </div>
    </div>
    <b-card no-body class="mb-3 cardcontainer">
      <b-card-body>
        <b-form inline class="" @submit="searchUser">
          <b-input class="mr-sm-2 mb-sm-0" :placeholder="$t('name')" v-model="lastname" />
          <b-input class="mr-sm-2 mb-sm-0" :placeholder="$t('firstname')" v-model="firstname" />
          <b-input class="mr-sm-2  mb-sm-0" :placeholder="$t('email')" v-model="email" />
          <b-select class="custom-select mr-sm-2  mb-sm-0" v-model="user_type" :value="$t('access_level') + '...'" :options=userTypeData />
          <b-btn type="submit" variant="primary">{{ $t('search')}}</b-btn>
        </b-form>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body>
        <b-table
                :items="usersData"
                :fields="fields"
                :striped="true"
                :bordered="true"
                class="card-table">

          <template :slot="$t('email')" slot-scope="data">
            {{data.item.email}}
          </template>
          <template  :slot="$t('name')" slot-scope="data">
            {{data.item.userprofile.lastname }}
          </template>
          <template  :slot="$t('firstname')" slot-scope="data">
            {{data.item.userprofile.firstname }}
          </template>
          <template  :slot="$t('access_level')" slot-scope="data">
            <template v-if="$cookie.get('language') == 'fr'">{{ data.item.userprofile.user_type.label }}</template>
            <template v-if="$cookie.get('language') == 'en'">{{ data.item.userprofile.user_type.label_en }}</template>
          </template>
          <template  :slot="$t('last_connexion')" slot-scope="data"> {{ data.item.last_connection|formatDateNoH }}</template>
          <template :slot="$t('status')" slot-scope="data">
            <b-badge variant="outline-success" v-if="data.item.status === 'ACT'">{{ $t('active')}}</b-badge>
            <b-badge variant="outline-default" v-if="data.item.status === 'INV'">{{ $t('guest')}}</b-badge>
            <b-badge variant="outline-danger" v-if="data.item.status === 'DEA'">{{ $t('deactivated')}}</b-badge>
          </template>
          <template slot="Actions" slot-scope="data">
            <b-btn v-bind:to="'/users/list/profile/' + data.item.id" variant="default btn-xs icon-btn md-btn-flat"
                   v-b-tooltip.hover title="Profil"><i class="ion ion-md-person"></i></b-btn>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <sweet-modal width="80%" ref="formodal" height="80%">
      <form @submit="addUserFile">
        <b-form-group :label="$t('file')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <input type="file"  id="documentUser"/>
        </b-form-group>
        <b-btn type="submit" variant="primary" slot="finish">{{ $t('addUserFile') }}</b-btn>
      </form>
    </sweet-modal>
  </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<script>
  import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
  import {
    ADMIN_GET_USERTYPES_REQUEST,
    ADMIN_GET_USERS_REQUEST,
    ADMIN_DELETE_USER_REQUEST
  } from "../_store/administration/user/actiontypes";
  import { mapState } from 'vuex';
  import Breadcumb from '../components/breadcumb'
  import XLSX from 'xlsx';
  import {ADD_USERFILE_REQUEST} from "../_store/user/actiontypes";
  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}));
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      if (file === undefined) {
        return resolve(null);
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      }
    });
  }
  export default {
    name: 'adminUserList',
    computed: mapState({ usersData: state => state.admin_user.users }),
    components: { Breadcumb, SweetModal, SweetModalTab},
    mounted() {
      this.fields = [
            {
              key: this.$i18n.t('name'),
              sortable: false,
              tdClass: 'align-middle'
            },
            {
              key: this.$t('firstname'),
              sortable: false,
              tdClass: 'align-middle'
            },
            {
              key: this.$t('email'),
              sortable: false,
              tdClass: 'align-middle'
            },
            {
              key: this.$t('access_level'),
              sortable: false,
              tdClass: 'align-middle'
            },
            {
              key: this.$t('last_connexion'),
              sortable: false,
              tdClass: 'align-middle'
            },
            {
              key: this.$t('status'),
              sortable: false,
              tdClass: 'align-middle'
            },
            {
              key: 'Actions',
              sortable: false,
              tdClass: 'align-middle'
            }
      ];
      this.breadcumbData = [
        { text: this.$t('welcome'), href: '/dashboard/' },
        { text: this.$t('users_list'), active: true },
      ];
      this.$store.dispatch(ADMIN_GET_USERS_REQUEST);
      this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST, {"max": 4})
              .then(response => {
                this.userTypeData = response.data.usertypes.map(userType => {
                  return {
                    value: userType.id,
                    text: userType.label
                  };
                });
              });
    },
    data() {
      return {
        breadcumbData: [],
        dataUrl: 'json/pages_users_list.json',
        lastname: null,
        firstname: null,
        document: null,
        email: null,
        userTypeData: [],
        company: null,
        user_type: null,
        fields: [],
        employeesData: [],
        currentPage: 1
      };
    },
    layout(context) {
      return 'layout';
    },
    methods: {
      addUserFile: function (e) {
        e.preventDefault();
        const reader = new FileReader();
        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type:'binary'});
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, {header:2});
          /* Update state */
          this.data = data;
          this.$store.dispatch(ADD_USERFILE_REQUEST, {
            "users": data
          })
                  .then(() => {
                      this.$refs.formodal.close();
                      this.$store.dispatch(ADMIN_GET_USERS_REQUEST);
                  })
          this.cols = make_cols(ws['!ref']);
        };
        reader.readAsBinaryString(document.getElementById('documentUser').files[0]);

      },
      deleteUser(id) {
        this.$store.dispatch(ADMIN_DELETE_USER_REQUEST, id)
                .then(() => {
                  this.$router.push('/users/list')
                })
                .catch(error => {
                  console.log(error)
                })
      },
      searchUser: function (e) {
        e.preventDefault();
        this.$store.dispatch(ADMIN_GET_USERS_REQUEST, {
          lastname: this.lastname,
          firstname: this.firstname,
          email: this.email,
          company: this.company,
          user_type: this.user_type
        })
      },
    },
  };
</script>
